import React from 'react';
import EditorSwap from '@wix/da-ds/pkg/Icons/24x24/EditorSwap';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import EditorImage from '@wix/da-ds/pkg/Icons/24x24/EditorImage';
import { popperDropdownConfig } from '../../../extension-deviation/constants';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';
const Convert = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "node:deviation:convert",
        "aria-label": t('ext.deviation.toolbar.convert'),
        tooltipText: t('ext.deviation.toolbar.convert'),
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        icon: EditorSwap,
        items: [
            {
                featureId: 'node:deviation:convertToLink',
                label: t('ext.deviation.toolbar.convert.toLink'),
                icon: /*#__PURE__*/ React.createElement(EditorLink, null),
                onClick: ()=>{
                    editor.chain().focus().daDeviationThumbToLink().run();
                }
            },
            {
                featureId: 'node:deviation:convertToThumb',
                label: t('ext.deviation.toolbar.convert.toFullview'),
                icon: /*#__PURE__*/ React.createElement(EditorImage, null),
                onClick: ()=>{
                    editor.chain().focus().daDeviationThumbConvertToFullview().run();
                }
            }
        ],
        popperManagerProps: popperDropdownConfig
    });
};
Convert.displayName = 'Convert';
export default Convert;

//# sourceMappingURL=Convert.js.map